import React from 'react';
import BottomPanel from '../../../BottomPanel';
import Button from '../../../Button';
import styled from 'styled-components';
import { breakpoints } from '../../../../utils/styles';

const Container = styled.div`
    text-align: center;
    @media screen and (min-width: ${breakpoints.desktop}px) {
        margin: 0 auto;
        width: 21rem;
    }
`;

const Title = styled.h1`
    font-family: var(--ff-title);
    font-size: 4rem !important;
    font-weight: 500;
    margin-bottom: 0.5rem !important;
    text-align: center;
    text-transform: uppercase;
    color: var(--text-primary) !important;
`;

const Subtitle = styled.p`
    font-family: var(--ff-subtitle);
    font-size: 1.75rem;
    font-weight: 400;
    margin-bottom: 1em !important;
    text-align: center;
`;

const Card = styled.img`
    display: block;
    margin-bottom: 2.25rem;
    width: 100%;
`;

const GiftInfo = styled.div`
    & > p {
        margin-bottom: 1em;
    }
`;

const GiftToName = styled.p`
    font-family: var(--ff-subtitle);
    font-size: 1.25em;
    font-weight: bold;
`;

interface Props {
    result: any;
}

const WalletBuyConfirmation: React.FC<Props> = ({ result }) => {
    const returnUrl = '/usuario/wallet';
    return (
        <BottomPanel open={true} onClose={() => document.location = returnUrl} desktopInline>
            <Title>¡Felicidades!</Title>
            
            <Subtitle>Tu compra fue completada 🤩</Subtitle>

            <Container>
                {result.image && (
                    <Card src={result.image} alt={result.name} />
                )}

                {!('giftType' in result) && (
                    <Button to={returnUrl} block>
                        Ver tarjeta en Wallet
                    </Button>
                )}

                {result.giftType && (
                    <GiftInfo>
                        <p>
                            La Tarjeta Digital fue enviada <strong>
                                {result.giftType === 'email' ? 'por mail' : 'por WhatsApp'}
                            </strong> a:
                        </p>
                        <GiftToName>
                            <strong>{result.giftToName}</strong>
                        </GiftToName>
                        <p>
                            {'email' === result.giftType ? result.giftToEmail : result.giftToPhone}
                        </p>
                        <p>
                            {result.giftMessage}
                        </p>
                    </GiftInfo>
                )}
            </Container>
        </BottomPanel>
    );
};

export default WalletBuyConfirmation;